import React from "react";
import {Form, Select, Input, InputNumber} from 'antd';
import NHFormItem from '../../common/NHFormItem/index';
import NHSelect from "../../common/NHSelect";

const FormItem = Form.Item;

class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lxjtgjmcList:{},
            options:{}
        }
    }


    //获取下拉列表value对应的名称
    getDmkMc = (dmbz) => {
        NHFetch(basicUrl + "/getDmkMc", "GET", {dmbz, dmbz})
            .then(res => {
                if (res) {
                    if (res.data) {
                        if(dmbz==="YXWZ_LXJTGJ"){
                            this.setState({lxjtgjmcList: res.data});
                            const options = res.data.map(item => {
                                return <Select.Option key={item.DM}>{item.MC}</Select.Option>;
                            });
                        }
                    }
                }
            });
    }
    render() {       
        const {form, initFormData} = this.props;
        const {options} = this.state;
        return (
            <div>
                <Form layout="horizontal">

                    <NHFormItem id={'ztlx'} label={'来校交通工具'} form={form} required={true}
                                initialValue={initFormData ? initFormData.ZTLX:'01'}>
                        <NHSelect sign={"dmk_yxwz_lxjtgj"}/>
                    </NHFormItem>
                    <NHFormItem id={'ztmc'} label={'站台名称'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 100, message: "站台名称长度不能超过100字符！"}}
                                initialValue={initFormData ? initFormData.ZTMC : ''}>
                        <Input placeholder="请输入站台名称"/>
                    </NHFormItem>

                </Form>
            </div>
        );
    }
}


const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/fwwgl/ztwh/EditForm.js